module.exports = __webpack_public_path__ + "static/img/7.272be3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/clix/7.png
// module id = FyVS
// module chunks = 35